import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

import ViewSession from 'workspaces/launcher/data/ViewSession';

type OnFetchSuccess = (items: Immutable.List<ViewSession>) => void;
type OnFetchMaxSessionsSuccess = (maxSessions: number) => void;
type OnError = (error: ErrorData) => void;

function fetch (
  onSuccess: OnFetchSuccess,
  onError: OnError
) {
  ConnectionSupport.post(
    'getViewSessions',
    {},
    (data) => {
      onSuccess(
        Immutable.List(data.map((session: object) => ViewSession.fromJS(session))));
    },
    onError
  );
}

function fetchMaxSessions (
  onSuccess: OnFetchMaxSessionsSuccess,
  onError: OnError
) {
  ConnectionSupport.post(
    'getMaxViewSessions',
    {},
    onSuccess,
    onError
  );
}

const ViewSessionsConnection = {
  fetch,
  fetchMaxSessions
};

export default ViewSessionsConnection;
